import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import NavContextProvider from './contexts/navigation';
import CurUserProvider from './contexts/curUser';
import LangContextProvider from './contexts/langContext';


ReactDOM.render(
  <React.StrictMode>
    <LangContextProvider>
    <CurUserProvider>
    <NavContextProvider>
      <App />
    </NavContextProvider>
    </CurUserProvider>
    </LangContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
